import{a as o}from"./chunk-EOJWPF3P.mjs";var t=class{constructor(n){this.config=n}async transferCoinTransaction(n){return o({aptosConfig:this.config,...n})}};export{t as a};
//# sourceMappingURL=chunk-5IRM54PL.mjs.map